<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__bcustomers}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button v-if="$hasPermission('sys:bcustomers:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:bcustomers:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item> -->
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="customerId" label="客户编号" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="name" label="用户姓名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="mobile" label="手机号" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="operationId" label="机构ID" header-align="center" align="center"></el-table-column>
        <el-table-column prop="channelId" label="渠道id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="companyId" label="所属公司" header-align="center" align="center"></el-table-column>
        <el-table-column prop="deptId" label="门店id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="pageId" label="来源落地页" header-align="center" align="center"></el-table-column>
        <el-table-column prop="type" label="0未回访1有效2无效" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="ip" label="访问IP" header-align="center" align="center"></el-table-column>
        <el-table-column prop="city" label="城市" header-align="center" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" header-align="center" align="center"></el-table-column>
        <el-table-column prop="url" label="访问URL" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createdAt" label="创建时间" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="updatedAt" label="更新时间" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="deletedAt" label="删除时间" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="isPush" label="是否推送" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="pushMsg" label="推送内容" header-align="center" align="center"></el-table-column>
        <el-table-column prop="pushDate" label="推送日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="cardno" label="身份证" header-align="center" align="center"></el-table-column>
        <el-table-column prop="isMarried" label="婚姻状况" header-align="center" align="center"></el-table-column>
        <el-table-column prop="education" label="教育程度" header-align="center" align="center"></el-table-column>
        <el-table-column prop="professional" label="职业" header-align="center" align="center"></el-table-column>
        <el-table-column prop="employmentTime" label="就业时长" header-align="center" align="center"></el-table-column>
        <el-table-column prop="monthlyIncome" label="月收入（元）" header-align="center" align="center"></el-table-column>
        <el-table-column prop="payrollType" label="工资发放形式" header-align="center" align="center"></el-table-column>
        <el-table-column prop="money" label="申请金额" header-align="center" align="center"></el-table-column>
        <el-table-column prop="usefor" label="贷款用途" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="loanLongTime" label="贷款期限" header-align="center" align="center"></el-table-column>
        <el-table-column prop="creditSituation" label="信用情况" header-align="center" align="center"></el-table-column>
        <el-table-column prop="isCredit" label="信用卡" header-align="center" align="center"></el-table-column>
        <el-table-column prop="shebao" label="社保" header-align="center" align="center"></el-table-column>
        <el-table-column prop="gongjijin" label="公积金" header-align="center" align="center"></el-table-column>
        <el-table-column prop="house" label="房产" header-align="center" align="center"></el-table-column>
        <el-table-column prop="car" label="车产" header-align="center" align="center"></el-table-column>
        <el-table-column prop="baodanIs" label="商业保险" header-align="center" align="center"></el-table-column>
        <el-table-column prop="zmscore" label="芝麻信用" header-align="center" align="center"></el-table-column>
        <el-table-column prop="weili" label="微粒贷" header-align="center" align="center"></el-table-column>
        <el-table-column prop="businesslicense" label="企业主" header-align="center" align="center"></el-table-column>
        <el-table-column prop="remark1" label="备注1" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="remark2" label="备注2" header-align="center" align="center"></el-table-column>
        <el-table-column prop="age" label="年齢" header-align="center" align="center"></el-table-column>
        <el-table-column prop="houseType" label="房屋类型" header-align="center" align="center"></el-table-column>
        <el-table-column prop="housePrice" label="房屋价格" header-align="center" align="center"></el-table-column>
        <el-table-column prop="houseSize" label="房屋面积" header-align="center" align="center"></el-table-column>
        <el-table-column prop="houseLife" label="房屋年限" header-align="center" align="center"></el-table-column>
        <el-table-column prop="carPrice" label="车辆价格" header-align="center" align="center"></el-table-column>
        <el-table-column prop="carType" label="新车|二手车" header-align="center" align="center"></el-table-column>
        <el-table-column prop="carModel" label="车型" header-align="center" align="center"></el-table-column>
        <el-table-column prop="carLife" label="车辆年限" header-align="center" align="center"></el-table-column>
        <el-table-column prop="transId" label="" header-align="center" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" header-align="center" align="center"></el-table-column>
        <el-table-column prop="loanType" label="贷款类型" header-align="center" align="center"></el-table-column>
        <el-table-column prop="ads" label="广告计划" header-align="center" align="center"></el-table-column>
        <el-table-column prop="creativeid" label="创意" header-align="center" align="center"></el-table-column>
        <el-table-column prop="returnMsg" label="返回信息" header-align="center" align="center"></el-table-column>
        <el-table-column prop="productId" label="产品id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="sex" label="性别" header-align="center" align="center"></el-table-column>
        <el-table-column prop="channelName" label="渠道名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="ucid" label="账户id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="clueId" label="线索id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="creator" label="创建人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateBy" label="更新人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateTime" label="更新日期" header-align="center" align="center"></el-table-column>
        <!-- <el-table-column prop="deleteTime" label="删除日期" header-align="center" align="center"></el-table-column> -->
        <!-- <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:bcustomers:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:bcustomers:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './bcustomers-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/bcustomers/page',
        getDataListIsPage: true,
        exportURL: '/sys/bcustomers/export',
        deleteURL: '/sys/bcustomers',
        deleteIsBatch: true
      },
      dataForm: {
        id: ''
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
